export const IMPORTING_BATCH_ADJUSTMENTS_SUCCESS = 'IMPORTING_BATCH_ADJUSTMENTS_SUCCESS';
export const IMPORTING_BATCH_ADJUSTMENTS_FAILURE = 'IMPORTING_BATCH_ADJUSTMENTS_FAILURE';
export const IMPORTING_BATCH_ADJUSTMENTS = 'IMPORTING_BATCH_ADJUSTMENTS';

export const UPLOAD_BATCH_ADJUSTMENTS = 'UPLOAD_BATCH_ADJUSTMENTS';
export const UPLOAD_BATCH_ADJUSTMENTS_SUCCESS = 'UPLOAD_BATCH_ADJUSTMENTS_SUCCESS';
export const UPLOAD_BATCH_ADJUSTMENTS_FAILURE = 'UPLOAD_BATCH_ADJUSTMENTS_FAILURE';

export const RESET_UPLOADED_BATCH_ADJUSTMENTS = 'RESET_UPLOADED_BATCH_ADJUSTMENTS';
